import React, {Fragment, SyntheticEvent, useEffect, useState} from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import {Checkbox, DialogTitle, FormLabel, ListItemText, OutlinedInput} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import charcreate from "../../_helper/charcreate";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_skills, s_char_talents, s_char_weapons} from "../../_signals/s_char";
import {ICharSkill} from "../../_interfaces/ICharSkill";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {SkillsCreate, SkillsDelete, SkillsUpdate} from "../../_api/BESkills";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import updChar from "../../_sig_api/updChar";
import {styled} from "@mui/material/styles";
import {InfoTalentSkillSubscriber} from "../../_helper/InfoTalentSkillBehave";
import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from "@mui/icons-material/Clear";
import {Check, DoneAll, SaveAlt} from "@mui/icons-material";
import getSkillDefines from "./getSkillDefines";
import {s_app_sl} from "../../_signals/s_app";
import {WeaponsCreate} from "../../_api/BEWeapons";
import CheckIcon from "@mui/icons-material/Check";
import skill_improvise from "../../_data/skill_improvise";
import Visibility from "@mui/icons-material/Visibility";
import Stack from "@mui/material/Stack";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

interface IProp {
    add: boolean,
    isOpen: (open: boolean) => void
}

function SkillsAdd({add, isOpen}: IProp) {
    useSignals()

    const [skill, setSkill] = useState<ICharSkill | null>(null)

    const allowedDupicates = ['Wissen', 'Kunsthandwerk']

    useEffect(() => {
        if (add) {
            const addSkill: ICharSkill = {
                id: v4(),
                cid: s_char.value.id,
                attribute: "",
                define: [],
                karma: false,
                lpstart: 0,
                name: "",
                step: 0,
                stepfree: 0,
                strain: 0,
                type: 2

            }
            setSkill(addSkill)
        } else setSkill(null)
    }, [add])

    const handleInfoPopOpen = (skillname: string, e: SyntheticEvent) => {
        const dataskill = TalentSkillSubscriber.value.find(s => s.hasOwnProperty('lps_skill') && s.name === skillname)
        if (dataskill) {
            InfoTalentSkillSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: dataskill})
        }
    }

    const save = () => {
        let skills = s_char_skills.value;
        if (skill && skill?.name !== '') {
            skills.unshift(skill);
            skills.sort((a, b) => a.name.localeCompare(b.name));
            s_char_skills.value = skills;
            SkillsCreate(skill)
            isOpen(false)
        } else isOpen(false)
    }

    const cancel = () => {
        setSkill(null)
        isOpen(false)
    }

    const getSkills = () => {
        let skills: ICharSkill[] = [];

        const existing = s_char_skills.value.map(s => s.name)

        for (let j = 0; j < TalentSkillSubscriber.value.length; j++) {
            const tsskill = TalentSkillSubscriber.value[j]
            if (!allowedDupicates.includes(tsskill.name) && existing.includes(tsskill.name)) continue
            if (tsskill.hasOwnProperty('lps_skill')) {
                const skill: ICharSkill = {
                    id: v4(),
                    cid: s_char.value.id,
                    name: tsskill.name,
                    lpstart: tsskill.lps_skill ?? 100,
                    step: 0,
                    stepfree: 0,
                    type: 2,
                    strain: tsskill.strain,
                    attribute: tsskill.attribute,
                    karma: false,
                    define: [],
                    define_single: tsskill.hasOwnProperty('define_single') ? tsskill.define_single : [],
                    define_multi: tsskill.hasOwnProperty('define_multi') ? tsskill.define_multi : [],
                    use_as: tsskill.hasOwnProperty('use_as') ? tsskill.use_as : ''
                }
                skills.push(skill);
            }
        }

        skills.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

        return skills;
    }

    const ccHint = (a: ICharSkill) => {
        if (a.lpstart == 200) return <DoneAll style={{float: 'left', paddingLeft: 8}}></DoneAll>
        if (a.lpstart == 300) return <Check style={{float: 'left', paddingLeft: 8}}></Check>
        if (a.lpstart == 500) return <Visibility style={{float: 'left', paddingLeft: 8}}></Visibility>
        return '';
    }

    return <Fragment>
        <Dialog open={add}>
            <DialogTitle>Neue Fertigkeit</DialogTitle>
            <DialogContent>
                <Select style={{width: '100%'}}
                        value={skill?.name}
                        onChange={(e) => setSkill({...skill, name: e.target.value} as ICharSkill)}>
                    {getSkills().map(a => <MenuItem key={v4()} value={a.name}>
                        <Stack direction={'row'} style={{width: '100%'}} justifyContent={'space-between'}>
                            <span>{a.name}</span>
                            {a.use_as ?
                                <span style={{fontSize: "smaller", paddingLeft: 8}}>gilt als {a.use_as}</span> : null}
                            {!s_char.value.cc_skills ? ccHint(a) : null}
                        </Stack>
                    </MenuItem>)}
                </Select>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => save()}><CheckIcon/></Button>
                <Button onClick={() => cancel()}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default SkillsAdd;
